import { z } from 'zod/v4';

import { mobileProductSchema } from './mobile-product.schema';
import { webProductSchema } from './web-product.schema';

export const companyProductsSchema = z.object({
  mobileProducts: z.array(mobileProductSchema),
  webProducts: z.array(webProductSchema),
});

export type CompanyProducts = z.infer<typeof companyProductsSchema>;
